import Api from '@/api/Api'
import DateUtils from '@utils/DateUtils'
import {get} from 'lodash/object'
import { size } from 'lodash/collection'
import { isEmpty, toString } from 'lodash/lang'

const TYPE = {
  image: {
    text: 'Image',
    value: 'image',
    color: '#08293B'
  },
  vector: {
    text: 'Vector',
    value: 'vector',
    color: '#579FC6'
  },
  model: {
    text: 'Model',
    value: 'model',
    color: '#1A82BA'
  },
  dataset: {
    text: 'Dataset',
    value: 'dataset',
    color: '#1A2F3B'
  },
  result: {
    text: 'Result',
    value: 'result',
    color: '#135E87'
  }
}

export const state = {
  items: [],
  query: {},
  q: null,
  page: 1,
  infiniteState: null,
  infiniteId: 0,
  isFetching: false
}

export const getters = {
  items: state => state.items.map(item => ({
    ...item,
    type: TYPE[item.type],
    createdAt: DateUtils.convertUTCToLocalDateTime(item.created_at),
    tags: {
      items: toString(item.categories),
      firstItem: get(item.categories, '0'),
      additional: size(item.categories) > 1 ? item.categories.length - 1 : null
    }
  })),
  query: state => state.query,
  isFetching: state => state.isFetching,
  total: state => state.total
}

export const mutations = {
  SET_ITEMS: (state, payload) => {
    state.items = payload
  },
  APPEND_ITEMS: (state, payload) => {
    state.items.push(...payload)
  },
  SET_PAGE: (state, payload) => {
    state.page = payload
  },
  INCREMENT_PAGE: (state, payload) => {
    state.page += 1
  },
  SET_IS_FETCHING: (state, payload) => {
    state.isFetching = payload
  },
  SET_INFINITE_STATE: (state, payload) => {
    state.infiniteState = payload
  },
  SET_QUERY: (state, payload) => {
    state.query = payload
  },
  INCREMENT_INFINITE_ID: (state, payload) => {
    state.infiniteId += 1
  },
  SET_Q: (state, payload) => {
    state.q = payload
  }
}

export const actions = {
  fetchItems: async ({commit, state}) => {
    try {
      commit('SET_IS_FETCHING', true)
      const {data} = await Api.searchFull(
        {
          page: get(state, 'page', 1),
          perPage: get(state.query, 'perPage', 12),
          q: isEmpty(state.q) ? null : state.q,
          workspaceIds: isEmpty(state.query.workspaceIds) ? null : JSON.stringify(state.query.workspaceIds),
          userIds: isEmpty(state.query.userIds) ? null : JSON.stringify(state.query.userIds),
          categories: isEmpty(state.query.categories) ? null : JSON.stringify(state.query.categories),
          from: get(state.query, 'from', null),
          to: get(state.query, 'to', null),
          types: isEmpty(state.query.types) ? null : JSON.stringify(state.query.types)
        }
      )
      if (!isEmpty(data.data)) {
        commit('INCREMENT_PAGE')
        commit('APPEND_ITEMS', data.data)
        commit('SET_INFINITE_STATE', 'loaded')
      } else {
        commit('SET_INFINITE_STATE', 'complete')
      }
    } catch (e) {
      throw e
    } finally {
      commit('SET_IS_FETCHING', false)
    }
  },
  filter: ({commit, dispatch, state}, payload) => {
    commit('SET_QUERY', payload)
    commit('SET_PAGE', 1)
    commit('SET_ITEMS', [])
    commit('INCREMENT_INFINITE_ID')
  },
  setQ: ({commit, dispatch}, payload) => {
    commit('SET_Q', payload)
  },
  resetState: ({commit}) => {
    commit('SET_QUERY', {})
    commit('SET_PAGE', 1)
    commit('SET_ITEMS', [])
  }
}



// WEBPACK FOOTER //
// ./src/state/modules/search.js